import { Button, Card, CardBody, Tab, Tabs, TabsHeader, Typography } from "@material-tailwind/react";
import TitleComponent from "../common/TitleComponent";
import { useEffect, useState } from "react";

const TreatmentContent = ({ treatmentData }) => {

  const [price, setPrice] = useState({
    treatmentPrice: treatmentData.price
  });

  const [treatment, setTreatment] = useState({
    type: 1
  })

  useEffect(() => {
    setPrice({ treatmentPrice: parseFloat(treatmentData.price) * parseFloat(treatment.type === 2 ? 2 : 1) });
  }, [treatment.type]);

  return (
    <>
      {/* <div className="my-8 bg-blue-300 sm:bg-red-300 md:bg-yellow-300 lg:bg-green-300 xl:bg-purple-300 2xl:bg-orange-300"> */}

      {/* <div className="px-5 pt-10">
        <div className="w-full flex flex-col items-center">
          <Typography className="tracking-widest text-[.6rem] xl:text-sm text-customMaroon-35 uppercase title_DMSerifText-Regular">
            Serene Elegance in Sri Lankan ayurveda
          </Typography>
        </div>
      </div> */}

      <TitleComponent Title={treatmentData.title} Subtitle={""} />

      <div className="my-8">
        <div className="w-full h-full flex flex-col lg:flex-row justify-center items-center">
          <div className="flex w-full lg:w-5/12 justify-center rtolblock">
            <div className="bg-center w-full h-full lg:block px-10 lg:px-0 xl:px-0">
              <img alt="treatment-image" src={treatmentData.src} />
            </div>
          </div>

          <div className="w-full lg:w-5/12 shadow-md  content-center ltorblock ">

            <div className="px-5 ">
              {/* <div className="w-full flex flex-col items-center">

                <Typography className="tracking-widest text-[.6rem] xl:text-sm text-customMaroon-35 uppercase title_DMSerifText-Regular">
                  Serene Elegance in Sri Lankan ayurveda
                </Typography>
              </div> */}

              {/* <Typography
                variant="h2"
                color="blue-gray"
                className="text-center px-5 lg:pt-3  title_DMSerifText-Regular uppercase lg:text-[2rem] text-[1.2rem]"
              >
                {treatmentData.title}
              </Typography> */}

              <div className="text-center px-1 md:px-16 xl:px-0">
                <div className="px-1">
                  <p className="description_AlegreyaSans-Light lg:leading-5 leading-tight text-xm">
                    {treatmentData.description}
                  </p>
                </div>
              </div>

              {/* <Card className="p-3 mb-5 bg-blue-300 sm:bg-red-300 md:bg-yellow-300 lg:bg-green-300 xl:bg-purple-300 2xl:bg-orange-300"> */}
              <Card className="my-5 border border-customMaroon-75">
                <CardBody>



                  <Typography variant="h5" color="blue-gray">
                    Price:  {price.treatmentPrice.toLocaleString("en-US")}LKR
                  </Typography>

                  <div className='py-3 lg:px-[5%]' >
                    <Tabs value={treatment.type}>
                      <TabsHeader>
                        <Tab value={1} onClick={() => setTreatment({ ...treatment, type: 1 })}>
                          Single
                        </Tab>
                        <Tab value={2} onClick={() => setTreatment({ ...treatment, type: 2 })}>
                          Couple
                        </Tab>
                      </TabsHeader>
                    </Tabs>
                  </div>

                  <div className="pt-2 flex items-center">
                    <Typography className="w-1/2" variant="h5" color="blue-gray">
                      Duration: {treatmentData.duration}
                    </Typography>
                    <Button fullWidth className="w-1/2 bg-customBeige-50">Book {treatmentData.title}</Button>;
                  </div>

                </CardBody>

              </Card>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TreatmentContent;
